import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EntityTypeCustomFieldSectionView } from '@services/http/clients/api-proxies';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-custom-field-placement-selector-editor',
    templateUrl: './custom-field-placement-selector-editor.component.html',
    styleUrls: ['./custom-field-placement-selector-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class CustomFieldPlacementSelectorEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    source: EntityTypeCustomFieldSectionView[] = [];
    selectedItem?: EntityTypeCustomFieldSectionView;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.source = this.additionalInfo?.source ?? [];

        if (this.bindingProperty) {
            this.selectedItem = this.getSection(this.bindingProperty);
        }
    }

    onSelectedItemChange() {
        this.bindingProperty = this.selectedItem?.id ?? null;
        this.valueChange.emit();
    }

    private getSection(id: number): EntityTypeCustomFieldSectionView | undefined {
        return this.source.find((el) => el.id === id);
    }
}
